import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import { InfoBox, InfoBoxItem } from 'components/InfoBox'
import { SRPRS } from 'Icon/srprs'
import * as React from 'react'
import { Entry, EntryProps } from '../../../data/entries/types'
import { Theme } from '../../../data/models/funnelOrder/theme'
import { FunnelStep } from '../../../data/ui'
import FunnelBreadcrumbs from '../../../elements/FunnelBreadcrumbs'
import DisplayContent from '../../shared/content'

interface FoodLoversHeroProps {
  entry: Entry
}

export const FoodLoversHero: React.FC<FoodLoversHeroProps> = ({ entry }) => {
  if (entry.page === undefined) {
    throw new Error('No page properties')
  }

  return (
    <Hero
      blurMobile
      type={HeroType.flavourEntry}
      headingColor={
        entry.page.style ? entry.page.style.headingColor : undefined
      }
      headingText={
        <DisplayContent contentKey="title">{entry.name}</DisplayContent>
      }
      subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
      src={entry.page.photos.src}
      src1024={entry.page.photos.src1024}
      src1280={entry.page.photos.src1280}
      src1600={entry.page.photos.src1600}
      src1920={entry.page.photos.src1920}
    >
      <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
      <Heading level={1}>
        <DisplayContent contentKey="title">{entry.name}</DisplayContent>
      </Heading>
      <InfoBox>
        <InfoBoxItem
          icon={SRPRS.calendarColored()}
          firstLine={
            <DisplayContent contentKey="1-info-top">3 - 14</DisplayContent>
          }
          secondLine={
            <DisplayContent contentKey="1-info-bottom">Dagen</DisplayContent>
          }
        />
        <InfoBoxItem
          icon={
            entry.theme === Theme.fly
              ? SRPRS.aeroplaneColored
              : SRPRS.carColored
          }
          firstLine={
            <DisplayContent contentKey="2-info-top">destination</DisplayContent>
          }
          secondLine={
            <DisplayContent contentKey="2-info-bottom">unknown</DisplayContent>
          }
        />
        <InfoBoxItem
          icon={SRPRS.mapMarkerColored}
          iconProps={{
            width: '34',
            height: '44',
            viewBox: '0 0 44 34',
            fill: 'none',
          }}
          firstLine={
            <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
          }
          secondLine={
            <DisplayContent contentKey="3-info-bottom">Europa</DisplayContent>
          }
        />
      </InfoBox>
    </Hero>
  )
}
